import { Icon } from "components";
import { Grid, Typography } from "e100-react-components";
import React from "react";

interface TrailerAxlesProps {
  axles: Nullable<number>;
}

export const TrailerAxles = ({ axles }: TrailerAxlesProps) => {
  return (
    <Grid container alignItems="flex-start">
      <Grid item>
        <Icon kind="axles"></Icon>
      </Grid>
      <Grid item>
        <Typography variant="subtitle2" color="textSecondary">
          {axles ?? 0}
        </Typography>
      </Grid>
    </Grid>
  );
};
